module.exports = __webpack_public_path__ + "static/api-235d9b91407f7ea2a3c054d6fd0fb6f9.png";